import axios from 'axios';
import dayjs from 'dayjs';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  vouchers: [],
  product: null,
  experienced_at: null,
  invoice_details: null,
  invoice_details_count: null,
  error: '',
};

const mutations = {
  set_vouchers(state, { orderDetails, product, invoiceDetails }) {
    state.vouchers = orderDetails;
    state.product = product;
    state.invoice_details = invoiceDetails;
  },
  failed_validation(state, message) {
    state.error = message.code[0];
  },
  set_invoice_details_count(state, count) {
    state.invoice_details_count = count;
  },
  reset_errors(state) {
    state.error = '';
  },
  set_experienced_at(state, date) {
    state.experienced_at = date;
  },
};

const actions = {
  async getInvoiceDetailsCount({ commit }) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/invoiceDetailCount`);
      commit('set_invoice_details_count', data);
    } catch ({ response }) {}
  },
  async validate({ commit }, { code, errors }) {
    if (code === null) {
      commit('reset_errors');
      commit('set_vouchers', { orderDetails: [], product: null, invoiceDetails: [] });
      return;
    }
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/validate-code`, { code });
      commit('set_vouchers', data);
      commit('reset_errors');
    } catch ({ response }) {
      commit('set_vouchers', { orderDetails: [], product: null });
      if (errors) {
        commit('failed_validation', response.data);
      }
    }
  },
  async use({ state, dispatch, commit }, orderDetail) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/use`, {
        useId: orderDetail.id,
        experienced_at: state.experienced_at ? dayjs(state.experienced_at) : null,
      });

      commit('reset_errors');

      if (state.vouchers.length > 1) {
        dispatch('validate', { code: orderDetail.code, errors: false });
      } else {
        commit('set_vouchers', { orderDetails: [], product: null, invoiceDetails: [] });
      }

      // if (state.vouchers.length > 1) {
      //   dispatch(
      //     'validate',
      //     state.vouchers.filter(od => od.id !== orderDetail.id).length > 0
      //       ? state.vouchers.map(od => od.code)[0]
      //       : null,
      //     false,
      //   );
      // } else {
      //   dispatch('validate', null, false);
      // }

      // commit('reset_errors');

      dispatch('invoices/getInvoices', {}, { root: true });

      return data;
    } catch (error) {
      console.log(error);
      commit('failed_validation', error.data);
    }

    return orderDetail;
  },
};

const getters = {
  orderDetails: state => state.vouchers,
  invoice_details: state => state.invoice_details,
  invoice_details_count: state => state.invoice_details_count,
  experienced_at: state => state.experienced_at,
  product: state => state.product,
  error: state => state.error,
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
